/**
 * Application Configuration
 * 
 * This file provides fallback values for environment variables
 * to ensure the app works even if build-time env vars aren't set.
 */

// Determine if we're in production based on hostname
const isProduction = typeof window !== 'undefined' && 
                     window.location.hostname === 'voxvault.app';

// Backend API URL with fallback
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 
                           (isProduction ? 'https://api.voxvault.app' : 'http://localhost:8000');

// Stripe publishable key — falls back to empty string if not set via env
export const STRIPE_PUBLISHABLE_KEY = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || '';

// Warn if Stripe key is not configured (common deployment issue)
if (!STRIPE_PUBLISHABLE_KEY) {
  console.warn(
    '[VoxVault] REACT_APP_STRIPE_PUBLISHABLE_KEY is not set. ' +
    'Stripe payments will not work. Set it in your .env file ' +
    '(e.g., REACT_APP_STRIPE_PUBLISHABLE_KEY=pk_test_... or pk_live_...).'
  );
}

// Log configuration in development
if (process.env.NODE_ENV === 'development') {
  console.log('App Configuration:', {
    BACKEND_URL,
    STRIPE_PUBLISHABLE_KEY: STRIPE_PUBLISHABLE_KEY ? '***' + STRIPE_PUBLISHABLE_KEY.slice(-4) : 'not set',
    isProduction
  });
}